import React from 'react';
import { Navbar } from '../Home/components/Navbar';
import { Footer } from '../Home/components/Footer';
import './StaticPages.css';

export const Terms = () => {
  return (
    <div className="static-page-wrapper hero-bg-listing-creative">
      <Navbar dark={true} />
      
      <div className="static-page-hero">
        <h1 className="static-page-title">Terms of Service</h1>
        <p className="static-page-subtitle">Last updated: January 2025</p>
      </div>

      <main className="static-page-content">
        <div className="static-page-container">
          <div className="legal-content">
            <section className="legal-section">
              <h2>1. Acceptance of Terms</h2>
              <p>
                By accessing or using Hobi's services, you agree to be bound by these Terms of Service. 
                If you do not agree to these terms, please do not use our services.
              </p>
            </section>

            <section className="legal-section">
              <h2>2. Use of Services</h2>
              <p>
                You must be at least 18 years old to use our services. You are responsible for 
                maintaining the confidentiality of your account credentials and for all activities 
                that occur under your account.
              </p>
            </section>

            <section className="legal-section">
              <h2>3. Event Bookings</h2>
              <p>
                When you book an event through Hobi, you enter into an agreement with the event 
                organizer. We facilitate this connection but are not responsible for the event 
                itself. Please review event details and organizer policies before booking.
              </p>
            </section>

            <section className="legal-section">
              <h2>4. Payments & Refunds</h2>
              <p>
                All payments are processed securely through our payment partners. Refund policies 
                are set by individual event organizers. Please review the refund policy for each 
                event before making a booking.
              </p>
            </section>

            <section className="legal-section">
              <h2>5. User Conduct</h2>
              <p>You agree not to:</p>
              <ul>
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe on the rights of others</li>
                <li>Submit false or misleading information</li>
                <li>Interfere with the proper functioning of our services</li>
                <li>Attempt to gain unauthorized access to our systems</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>6. Intellectual Property</h2>
              <p>
                All content on Hobi, including text, graphics, logos, and software, is the property 
                of Hobihub Services Private Limited and is protected by intellectual property laws.
              </p>
            </section>

            <section className="legal-section">
              <h2>7. Limitation of Liability</h2>
              <p>
                Hobi is not liable for any indirect, incidental, special, or consequential damages 
                arising from your use of our services. Our total liability is limited to the amount 
                you paid for the specific booking in question.
              </p>
            </section>

            <section className="legal-section">
              <h2>8. Changes to Terms</h2>
              <p>
                We may update these terms from time to time. We will notify you of significant 
                changes by email or through our platform. Continued use of our services after 
                changes constitutes acceptance of the new terms.
              </p>
            </section>

            <section className="legal-section">
              <h2>9. Contact</h2>
              <p>
                For questions about these Terms of Service, please contact us at{' '}
                <strong>legal@hobi.com</strong>
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};
